import _ from "lodash";

export const findOrCreateAddress = async ({
  addressString,
  onlineState,
  userId,
  incidentId,
  getAddressAutoSuggest,
  throttledAddOrUpdateAddress,
  handleUuid,
}) => {
  const normalized =
    typeof addressString === "string" ? addressString.trim() : "";
  if (!normalized) {
    return null;
  }

  let res;
  if (onlineState && typeof getAddressAutoSuggest === "function") {
    try {
      res = await getAddressAutoSuggest({
        originatorId: userId,
        input: normalized,
        count: 1,
      });
    } catch (error) {
      console.error(error);
    }
  }

  const suggestions = res?.data?.addressAutoSuggest;
  if (Array.isArray(suggestions) && suggestions.length > 0) {
    return suggestions[0]?.id ?? null;
  }

  const addressArr = normalized.split(",").map(i => i.trim());
  const streetPart = addressArr[0] || "";
  const streetArr = streetPart.split(" ").filter(Boolean);
  const streetNumber = streetArr.shift() || "";
  const streetName = streetArr.join(" ");
  const cityPart = addressArr[1];
  const city = cityPart
    ? cityPart
        .split(" ")
        .filter(Boolean)
        .map(i => _.capitalize(i))
        .join(" ")
    : undefined;
  const state = addressArr[2]?.trim() || undefined;
  const zip = addressArr[3]?.trim() || undefined;
  const addressUuid = handleUuid ? handleUuid() : null;
  if (!addressUuid || typeof throttledAddOrUpdateAddress !== "function") {
    return addressUuid;
  }

  if (onlineState) {
    const addressRes = await throttledAddOrUpdateAddress({
      variables: {
        input: {
          originatorId: userId,
          incidentId: incidentId ? incidentId : null,
          id: addressUuid,
          streetNumber: streetNumber,
          streetName: streetName,
          city: city,
          state: state,
          zip: zip,
        },
      },
      context: {
        serializationKey: "incidentQueue",
      },
    });
    return addressRes?.data?.addOrUpdateAddress?.address?.id ?? addressUuid;
  }

  throttledAddOrUpdateAddress({
    variables: {
      input: {
        originatorId: userId,
        incidentId: incidentId ? incidentId : null,
        id: addressUuid,
        streetNumber: streetNumber,
        streetName: streetName,
        city: city,
        state: state,
        zip: zip,
      },
    },
    context: {
      serializationKey: "incidentQueue",
    },
  });
  return addressUuid;
};
